import { Layout } from 'antd';
import styled from 'styled-components';

export const Main = styled(Layout.Content)`
	background-color: #fff;
	font-size: 16px;
`;
